import ConstantConverter from "../Parser/ConstantConverter";
/**
 * The accessor class to be used for fetching animation frames
 */
export default class Accessor {
    constructor(buffer, count, componentType, elementSize, byteOffset, byteStride) {
        this.buffer = buffer;
        this.count = count;
        this.componentType = componentType;
        this.elementSize = elementSize;
        this.byteOffset = byteOffset;
        this.byteStride = byteStride;
        this._dView = new DataView(buffer.buffer, buffer.byteOffset + byteOffset);
        this._elementByteSize = ConstantConverter.asByteSize(componentType);
        if (byteStride === 0) {
            this.byteStride = this.elementSize * this._elementByteSize;
        }
    }
    getByIndex(index) {
        if (index < 0 || index >= this.count) {
            return null;
        }
        const res = new Array(this.elementSize);
        for (let i = 0; i < this.elementSize; i++) {
            res[i] = this._getSingleByIndex(index, i);
        }
        return res;
    }
    _getSingleByIndex(index, elementIndex) {
        switch (this.componentType) {
            case WebGLRenderingContext.FLOAT:
                return this._dView.getFloat32(index * this.byteStride + this._elementByteSize * elementIndex, true);
            default:
                throw new Error("Unsupported element type");
        }
    }
}



// WEBPACK FOOTER //
// ./src/Accessor/Accessor.ts